<template>
  <div>
    <a v-if="!visible" @click="force = true">
      <IconText icon="mdi-help has-text-info"
        ><span class="has-text-info">Help</span></IconText
      ></a
    >

    <transition
      name="custom-classes-transition"
      enter-active-class="pulse-fast-once"
      appear
    >
      <div
        class="margin-top-10 margin-bottom-10 is-unselectable"
        v-if="firstLoadDone && visible"
      >
        <div class="notification is-primary is-light">
          <button class="delete is-small" @click="save()"></button>
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "tips-notification",
  components: { IconText: () => import("@/components/singles/IconText.vue") },
  props: {
    path: String,
    xKey: String,
    property: String,
  },
  computed: {
    visible() {
      return (
        !(
          this.$store.state.settings.user[this.path] &&
          this.$store.state.settings.user[this.path][this.xKey] &&
          this.$store.state.settings.user[this.path][this.xKey][this.property]
        ) || this.force
      );
    },
  },

  data() {
    return {
      firstLoadDone: false,
      force: false,
    };
  },

  async created() {
    await this.$store.dispatch("settings/getUserSetting", {
      path: this.path,
      xKey: this.xKey,
    });

    this.firstLoadDone = true;
  },

  methods: {
    async save() {
      const value = { ...this.$store.state.settings.user[this.path] };
      if (value[this.xKey] === undefined) value[this.xKey] = {};

      value[this.xKey][this.property] = true;

      await this.$store.dispatch("settings/setUser", {
        path: this.path,
        key: this.xKey,
        value: value[this.xKey],
      });

      this.force = false;
      this.$emit("hide");
    },
  },
};
</script>
